import { useState } from 'react'
import BookDTO, { BasicBrandingArray } from '../../DTO/BookDTO'
import './BookBrandingEditor.scss'
import BrandingDisplay from './BrandingDisplay'

export type CallBackFkt = (id: number, cb: () => void) => void
export type OpenFileSelectorFkt = (cb: CallBackFkt) => void

export function BookBrandingEditor(props: {
  book?: BookDTO,
  openFileSelector: OpenFileSelectorFkt,
}) {
  const [reload, setReload] = useState(0)
  return <div className="BookBrandingEditor">
    Wasserzeichen
    {
      BasicBrandingArray.filter((bba) => bba[0] !== 'none').map((bba, index) => {
        return <div key={`branding-${index}`}>
          <div><b>{bba[1]}</b></div>
          <div>
            <BrandingDisplay
              scheme={bba[0]}
              hide={false}
              preview={true}
              reload={reload}
              book={props.book}
            />
          </div>
          <div>
            <button
              onClick={() => {
                props.openFileSelector((id: number, cb: () => void) => {
                  console.log('SET BRANDING FILE ', id, ' for ', bba[1])
                  if (props.book) {
                    if (id > -1) {
                      props.book.addProp({
                        id: -1,
                        key1: 'branding',
                        key2: bba[0],
                        value1: id + '',
                        value2: '-',
                        fileId: id
                      }).then(() => {
                        props.book?.getFromServer().then(() => {
                          console.log('Setting File done!')
                          cb()
                        })
                      })
                    } else {
                      // entkoppeln:
                      props.book.removeProp('branding', bba[0]).then(() => {
                        props.book?.getFromServer().then(() => {
                          cb()
                          setReload(reload + 1)
                        })
                      })
                    }
                  }
                  // props.book.setBranding(bba[0], id)
                })
              }}
            >Auswählen</button>
            <button
              onClick={() => {
                if (props.book) {
                  props.book.removeProp('branding', bba[0]).then(() => {
                    props.book?.getFromServer().then(() => {
                      setReload(reload + 1)
                    })
                  })
                }
              }}
            >Zurücksetzen</button>
          </div>
        </div>
      })
    }
  </div>
}
